import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/FIS');

export default function FISPersonHint() {
  return <Content />;
}
